import Page from "../components/Page";


const PublicRoutes = [
    {path: '/vtimeteach', exact: true, name: "Index", component: Page}
]

export default PublicRoutes;